import { tinyCookie } from '../dependencies/tiny-cookie.js';
import log from './log.js';

//https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
function storageAvailable() {
  try {
    var storage = window['localStorage'],
        x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
    // everything except Firefox
    e.code === 22 ||
    // Firefox
    e.code === 1014 ||
    // test name field too, because code might not be present
    // everything except Firefox
    e.name === 'QuotaExceededError' ||
    // Firefox
    e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
    // acknowledge QuotaExceededError only if there's something already stored
    storage && storage.length !== 0;
  }
}

let isStorageAvailable = storageAvailable();
if (!isStorageAvailable) {
  log.info("Can not use localstorage/sessionstorage, falling back to reading temporary storage");
}

let temporary_storage = {};

export default class PersistentStorage {

  constructor() {
    var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.usingLocalStorage = !is_safari; //This is still needed due to the iframe that is used to do the CSRF check in the tenancy dashboard when using the single login page
    this.useSessionStorage = this.get("useSessionStorage");
  }

  enabled() {
    if (this.usingLocalStorage) {
      return isStorageAvailable;
    } else {
      return tinyCookie.isEnabled();
    }
  }

  get(name) {
    if (this.usingLocalStorage) {
      var item;
      if (isStorageAvailable) {
        if (this.useSessionStorage === true) {
          item = sessionStorage.getItem(name);
        } else {
          item = localStorage.getItem(name);
        }
      } else {
        item = temporary_storage[name];
      }

      if (item) {
        try {
          item = JSON.parse(item);
          return item.d;
        } catch (e) {
          return item;
        }
      }
    } else {
      var item;
      if (tinyCookie.isEnabled()) {
        item = tinyCookie.get(name);
      } else {
        item = temporary_storage[name];
      }

      if (item) {
        try {
          item = JSON.parse(item);
          return item.d;
        } catch (e) {
          return item;
        }
      }
    }
    return null;
  }

  set(name, value) {
    var to_store = JSON.stringify({ d: value });
    if (this.usingLocalStorage) {
      if (isStorageAvailable) {
        if (this.useSessionStorage === true && name != "useSessionStorage") {
          sessionStorage.setItem(name, to_store);
        } else {
          localStorage.setItem(name, to_store);
        }
      } else {
        temporary_storage[name] = to_store;
      }
    } else {
      if (tinyCookie.isEnabled()) {
        tinyCookie.set(name, to_store);
      } else {
        temporary_storage[name] = to_store;
      }
    }
  }

  setUseSessionStorage(use_session_storage) {
    this.set("useSessionStorage", use_session_storage);
    this.useSessionStorage = use_session_storage;
  }
}

export var persistentStorage = new PersistentStorage();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/persistentstorage.js
// module id = j8A9
// module chunks = 1 2 3 4 5 6